import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'paramFilter',
    standalone: false
})
export class ParamFilterPipe implements PipeTransform {

  transform(arr: any, showAA: boolean, showA: boolean, showB: boolean, showC: boolean, selectedParams: any): any {
    let transformedList = arr;
    // criticality filter
    transformedList = transformedList.filter(
      (element) => {
        if ((element.classification === 'AA' && showAA) ||
          (element.classification === 'A' && showA) ||
          (element.classification === 'B' && showB) ||
          (element.classification === 'C' && showC)) {
          return element;
        }
      });

    return transformedList;
  }

}
